import { render, staticRenderFns } from "./MaterialDepotStockList.vue?vue&type=template&id=a31c3980&scoped=true"
import script from "./MaterialDepotStockList.vue?vue&type=script&lang=js"
export * from "./MaterialDepotStockList.vue?vue&type=script&lang=js"
import style0 from "./MaterialDepotStockList.vue?vue&type=style&index=0&id=a31c3980&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31c3980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a31c3980')) {
      api.createRecord('a31c3980', component.options)
    } else {
      api.reload('a31c3980', component.options)
    }
    module.hot.accept("./MaterialDepotStockList.vue?vue&type=template&id=a31c3980&scoped=true", function () {
      api.rerender('a31c3980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/modules/MaterialDepotStockList.vue"
export default component.exports